import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

// Uses sessionStorage rather than localStorage so each browser tab keeps
// its own independent login. This lets a doctor and a receptionist be
// logged in at the same time in two tabs of the same browser, which
// localStorage (shared across all tabs of an origin) does not allow.
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('dq_token');
    const storedUser = sessionStorage.getItem('dq_user');
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        sessionStorage.removeItem('dq_token');
        sessionStorage.removeItem('dq_user');
      }
    }
    setLoading(false);
  }, []);

  async function login(username, password) {
    const res = await api.post('/auth/login', { username, password });
    const { token, user: userData } = res.data;
    sessionStorage.setItem('dq_token', token);
    sessionStorage.setItem('dq_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  }

  function logout() {
    sessionStorage.removeItem('dq_token');
    sessionStorage.removeItem('dq_user');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
